import React from "react";
import "./location.scss";

const Location = () => {
  return (
    <div className="locationWrapper">
      <img
        className="bluePrintLeft"
        src="/images/accomplishment/BlueprintLeft.png"
        alt="..."
      />
      <img
        className="bluePrintRight"
        src="/images/accomplishment/BlueprintRight.png"
        alt="..."
      />
      <img
        className="bluePrintMid"
        src="/images/accomplishment/blueprintMid.png"
        alt="..."
      />
      <img
        className="bluePrintBottom"
        src="/images/accomplishment/blueprintBottom.png"
        alt="..."
      />

      <div className="topLocationContainer">
        <div className="div1">
          <div className="topLocationLeft">
            <p className="location-heading">Exterior Restoration/Roofing</p>
            <span className="location-para">
              Exterior restoration and roofing are crucial aspects of property
              maintenance and enhancement. Whether it’s revitalizing the facade
              of a historic building or ensuring the weatherproofing integrity
              of a modern structure, these services play a pivotal role in
              preserving the aesthetics and structural integrity of a property.
              Professional exterior restoration and roofing companies employ a
              range of techniques and materials to repair, upgrade, or replace
              exterior surfaces and roofing systems. From repairing
              weather-related damage to implementing energy-efficient solutions,
              these experts contribute significantly to property longevity and
              value.
            </span>
          </div>
          <div className="topLocationRight">
            <p className="location-heading2">Location</p>
            <ul>
              <li>
                360 condominium, 7900 Harbor Island Drive, North Bay Village, FL
                33141.
              </li>
              <li>
                {" "}
                Celebration point, 15549 Miami Lakeway N, Miami Lakes, FL 33014.{" "}
              </li>
              <li>Doria Condo, 2175 NE 56th St, Fort Lauderdale, FL 33308.</li>
              <li>Environ 2, 7400 Radice Ct, Lauderhill, FL 33319.</li>
              <li>
                {" "}
                Cambridge Square Apartments, 6741 Johnson St, Hollywood, FL
                33024.
              </li>
              <li>
                THE CASABLANCA ON THE OCEAN HOTEL, 6345 Collins Ave, Miami
                Beach, FL 33141.
              </li>
              <li>
                Point of Americas, 2100 S Ocean Ln, Fort Lauderdale, FL 33316.
              </li>
              <li>
                {" "}
                The Grandview Condominiums, 5900 Collins Ave, Miami Beach, FL
                33140.
              </li>
              <li>
                Icon Brickell Apartments, 485 Brickell Ave SUITE 2204, Miami, FL
                33131.
              </li>
              <li>
                Brickell Heights Condominium Association, 55 SW 9th St, Miami,
                FL 33130.
              </li>
              <li>
                Lehrman Community Day School, 727 77th St, Miami Beach, FL
                33141.
              </li>
              <li>Biscayne Cove, 18151 NE 31st Ct #101, Aventura, FL 33160.</li>
              <li> Regatta CONDO, 6580 Indian Creek Dr, Miami, FL 33141.</li>
              <li>
                Florida Ocean Club, 17275 Collins Ave, Sunny Isles Beach, FL
                33160.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="midLocationContainer">
        <div className="div2">
        <div className="midLocationLeft">
          <p className="location-heading2">Location</p>
          <ul>
            <li>
              360 condominium, 7900 Harbor Island Drive, North Bay Village, FL
              33141.
            </li>
            <li>
              {" "}
              Celebration point, 15549 Miami Lakeway N, Miami Lakes, FL 33014.{" "}
            </li>
            <li>Doria Condo, 2175 NE 56th St, Fort Lauderdale, FL 33308.</li>
            <li>Environ 2, 7400 Radice Ct, Lauderhill, FL 33319.</li>
            <li>
              {" "}
              Cambridge Square Apartments, 6741 Johnson St, Hollywood, FL 33024.
            </li>
            <li>
              THE CASABLANCA ON THE OCEAN HOTEL, 6345 Collins Ave, Miami Beach,
              FL 33141.
            </li>
            <li>
              Point of Americas, 2100 S Ocean Ln, Fort Lauderdale, FL 33316.
            </li>
            <li>
              {" "}
              The Grandview Condominiums, 5900 Collins Ave, Miami Beach, FL
              33140.
            </li>
            <li>
              Icon Brickell Apartments, 485 Brickell Ave SUITE 2204, Miami, FL
              33131.
            </li>
            <li>
              Brickell Heights Condominium Association, 55 SW 9th St, Miami, FL
              33130.
            </li>
            <li>
              Lehrman Community Day School, 727 77th St, Miami Beach, FL 33141.
            </li>
            <li>Biscayne Cove, 18151 NE 31st Ct #101, Aventura, FL 33160.</li>
            <li> Regatta CONDO, 6580 Indian Creek Dr, Miami, FL 33141.</li>
            <li>
              Florida Ocean Club, 17275 Collins Ave, Sunny Isles Beach, FL
              33160.
            </li>
            <li>
              Eden Roc Miami Beach, 4525 Collins Ave, Miami Beach, FL 33140.
            </li>
          </ul>
        </div>
        <div className="midLocationRight">
          <p className="location-heading">Exterior Restoration/Roofing</p>
          <span className="location-para">
            Interior renovation is a transformative process that breathes new
            life into the heart of a building. Whether it’s a residential space,
            a commercial establishment, or an office, interior renovations can
            completely revamp the aesthetics, functionality, and comfort of an
            environment. Skilled professionals in the field utilize their
            expertise to redesign layouts, update materials and finishes, and
            enhance the overall ambiance of an interior space. From modernizing
            kitchens and bathrooms to creating open-concept living areas,
            interior renovations cater to the specific needs and preferences of
            property owners. The result is not only an aesthetically pleasing
            interior but also an improved quality of life and increased property
            value.
          </span>
        </div>
        </div>
     
      </div>
    </div>
  );
};

export default Location;
